export const EventTemplateOptionTypes = ['static text', 'text', 'dropdown', 'checkboxes', 'radio buttons']
export const EventTemplateVisibilityOptionTypes = ['always', 'show if', 'hide if']
export const EventTemplateButtonColorOptions = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark']
